/**
 * Kontakte + Identitaeten (Spec 3.2 / 5.2).
 *
 * Ein Contact ist die Person hinter den Tickets. Seine Identitaeten sind die
 * Adressen, unter denen er in den Quellsystemen auftaucht:
 *   - `app_user` — externe User-ID **innerhalb einer Quelle**
 *   - `email`    — E-Mail-Adresse, quellenuebergreifend
 *
 * Zuordnungsreihenfolge (Spec 5.2): erst `source + external_user_id`, sonst
 * E-Mail, sonst neuer Contact.
 */
import { z } from 'zod';
import { emailSchema, uuidSchema } from './common.js';
export const CONTACT_IDENTITY_TYPES = ['email', 'app_user'];
export const contactIdentityTypeSchema = z.enum(CONTACT_IDENTITY_TYPES);
export const contactIdentitySchema = z.object({
    id: uuidSchema,
    contact_id: uuidSchema,
    type: contactIdentityTypeSchema,
    /** Nur bei `app_user` gesetzt — eine externe User-ID gilt je Quelle. */
    source_id: uuidSchema.nullable(),
    value: z.string().min(1).max(320),
    created_at: z.iso.datetime(),
});
export const contactSchema = z.object({
    id: uuidSchema,
    tenant_id: uuidSchema,
    display_name: z.string().min(1).max(200),
    primary_email: emailSchema.nullable(),
    notes: z.string().max(10_000).nullable(),
    created_at: z.iso.datetime(),
    updated_at: z.iso.datetime(),
});
export const contactDetailSchema = contactSchema.extend({
    identities: z.array(contactIdentitySchema),
    ticket_count: z.number().int().min(0),
});
export const createContactSchema = z.object({
    display_name: z.string().min(1).max(200),
    primary_email: emailSchema.nullable().optional(),
    notes: z.string().max(10_000).nullable().optional(),
});
export const updateContactSchema = createContactSchema.partial();
/**
 * Eingangsdaten der Zuordnungslogik (Spec 5.2). Mindestens eines von
 * `external_user_id` (mit `source_id`) oder `email` muss gesetzt sein — sonst
 * gibt es nichts zu matchen und es entsteht immer ein neuer Contact.
 */
export const resolveContactSchema = z.object({
    source_id: uuidSchema.nullable().default(null),
    external_user_id: z.string().min(1).max(320).nullable().default(null),
    email: emailSchema.nullable().default(null),
    name: z.string().min(1).max(200).nullable().default(null),
});
export const contactListQuerySchema = z.object({
    q: z.string().max(200).optional(),
});
//# sourceMappingURL=contact.js.map